<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="container">
    <div class="row">

      <!--<div class="col-lg-6 mobile-view pop-left">

        <div class="logo-wraper">

          <img src="../assets/Images/logo.png" />
        </div>
        <h3>
          
        </h3>
        

      </div>-->
      <div class="col-lg-12 set-mobile">
        <button mat-button class="close-button" [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>

        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Zenithguard Learning Management Login</h4>
        </div>
        <div class="modal-body">

          <form (ngSubmit)="login(loginForm.value)" [formGroup]="loginForm" style="display:grid;">

            <mat-form-field>
              <input matInput placeholder="Email/Mobile Number" formControlName="userName" maxlength="100" required />
              <mat-error *ngIf="submitted && fl.userName.errors">
                Enter Email/Mobile Number
              </mat-error>


            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Password" formControlName="password" type="password" maxlength="20" minlength="8" required>
              <mat-error *ngIf="submitted && fl.password.errors?.required">
                Enter Password
              </mat-error>
              <mat-error *ngIf="fl.password.hasError('pattern')">
                Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
              </mat-error>
            </mat-form-field>

            <!--<mat-form-field>
              <mat-label>Select Currency Country</mat-label>
              <mat-select formControlName="serviceId" matTooltip="Select Currency Country" autocomplete="off" required>

                <mat-option *ngFor="let d of ServiceCountryList; let i=index" [value]="d.serviceId">
                  {{d.serviceProvider}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="submitted && fl.serviceId.errors">
                Select Currency Country
              </mat-error>


            </mat-form-field>-->

            <span>
              <a class="forgot-password" (click)="openModal()">Forgot Password?</a>
            </span>
            <button type="submit" mat-raised-button color="primary" class="login-btn"
                    style="margin-top: 20px;background-color:#f44a4a;color:white !important;" [disabled]="!loginForm.valid">Login</button>

          </form>



        </div>

      </div>


    </div>
  </div>
</fieldset>
